export enum ShowModalTypes {
  SET = '@showModal/SET',
}
